const WarningIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28" cy="28" r="28" fill="#93935F" fillOpacity="0.28" />
      <g transform="translate(13, 13)">
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 15C0 6.71572 6.71572 0 15 0C23.2842 0 30 6.71572 30 15C30 23.2842 23.2842 30 15 30C6.71572 30 0 23.2842 0 15ZM13.5 16.5C13.5 17.3284 14.1715 18 15 18C15.8284 18 16.5 17.3284 16.5 16.5V9C16.5 8.17158 15.8284 7.5 15 7.5C14.1715 7.5 13.5 8.17158 13.5 9V16.5ZM16.5 20.9832C16.5 20.1547 15.8284 19.4832 15 19.4832C14.1715 19.4832 13.5 20.1547 13.5 20.9832V21C13.5 21.8285 14.1715 22.5 15 22.5C15.8284 22.5 16.5 21.8285 16.5 21V20.9832Z"
            fill="#CFAF2D"
          />
        </svg>
      </g>
    </svg>
  );
};

export default WarningIcon;
